import { Appointment } from '../services/appointmentService';

export interface FirstAppointmentDates {
  startDate: string;
  startTime: string;
  dateTime: string;
}

/**
 * Extracts formatted date information from the first (earliest) appointment.
 * @param appointments Array of appointments to process
 * @returns Object with startDate (DD/MM/YYYY), startTime (HH:MM), and dateTime (DD/MM/YYYY HH:MM), or null if no valid appointments
 */
export const getFirstAppointmentDates = (appointments: Appointment[] | undefined | null): FirstAppointmentDates | null => {
  if (!appointments?.length) return null;

  const sorted = [...appointments].sort((a, b) =>
    new Date(a.startTime).getTime() - new Date(b.startTime).getTime()
  );

  const first = sorted[0];
  if (!first?.startTime) return null;

  const startDateTime = new Date(first.startTime);
  return {
    startDate: startDateTime.toLocaleDateString('en-GB'),
    startTime: startDateTime.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }),
    dateTime: `${startDateTime.toLocaleDateString('en-GB')} ${startDateTime.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`
  };
};

/**
 * Sorts appointments by start time (earliest first)
 * @param appointments Array of appointments to sort
 * @returns Sorted array of appointments
 */
export const sortAppointmentsByStartTime = (appointments: Appointment[]): Appointment[] => {
  return [...appointments].sort((a, b) =>
    new Date(a.startTime).getTime() - new Date(b.startTime).getTime()
  );
};
